import { render, staticRenderFns } from "./CheckQuick.vue?vue&type=template&id=f9237820"
import script from "./CheckQuick.vue?vue&type=script&lang=ts"
export * from "./CheckQuick.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports